import * as d3 from 'd3-delaunay';
import { Parcel } from '../types';
import { CLASSES, MAP_M, HA, GRID } from '../constants/landUseConfig';
import { mulberry32, shuffle } from './randomGenerator';

function polygonAreaM2(pts: [number, number][]): number {
  let area2 = 0;
  for (let i = 0; i < pts.length; i++) {
    const [x1, y1] = pts[i];
    const [x2, y2] = pts[(i + 1) % pts.length];
    area2 += x1 * y2 - x2 * y1;
  }
  return Math.abs(area2) / 2;
}

export function generateScenario(seed: number): Parcel[] {
  const rng = mulberry32(seed);
  const cellSize = MAP_M / GRID;
  const gridCells: [number, number][] = [];

  for (let gy = 0; gy < GRID; gy++) {
    for (let gx = 0; gx < GRID; gx++) {
      gridCells.push([gx, gy]);
    }
  }

  const shuffledCells = shuffle(gridCells, rng);
  const classAssignment: string[] = [];
  CLASSES.forEach((c) => {
    for (let i = 0; i < 5; i++) {
      classAssignment.push(c.id);
    }
  });

  const sites = shuffledCells.map(([gx, gy], idx) => {
    const jitter = cellSize * 0.32;
    const cx = gx * cellSize + cellSize / 2 + (rng() - 0.5) * 2 * jitter;
    const cy = gy * cellSize + cellSize / 2 + (rng() - 0.5) * 2 * jitter;
    return { x: cx, y: cy, cls: classAssignment[idx] };
  });

  const delaunay = d3.Delaunay.from(sites.map((s) => [s.x, s.y]));
  const voronoi = delaunay.voronoi([0, 0, MAP_M, MAP_M]);

  return sites.map((s, i) => {
    const cell = voronoi.cellPolygon(i) || [];
    const areaM2 = polygonAreaM2(cell as [number, number][]);
    const soilZone = s.x < MAP_M / 2 ? 'organic' : 'mineral';
    return {
      id: 'p' + i,
      cls: s.cls,
      pts: cell as [number, number][],
      areaHa: areaM2 / HA,
      soilZone: soilZone as 'organic' | 'mineral',
    };
  });
}

export function polygonCentroid(pts: [number, number][]): [number, number] {
  let cx = 0,
    cy = 0,
    n = 0;
  pts.forEach(([x, y]) => {
    cx += x;
    cy += y;
    n++;
  });
  return n ? [cx / n, cy / n] : [0, 0];
}